<template>
  <svg :width="width" :height="height" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="caret"
      d="M2.74868 4.125H9.25132C9.46976 4.125 9.62098 4.2267 9.70499 4.4301C9.78901 4.63351 9.7554 4.80843 9.60418 4.95488L6.35286 8.10355C6.25204 8.20118 6.13442 8.25 6 8.25C5.86558 8.25 5.74796 8.20118 5.64714 8.10355L2.39582 4.95488C2.2446 4.80843 2.21099 4.63351 2.29501 4.4301C2.37902 4.2267 2.53024 4.125 2.74868 4.125Z"
      fill="#4B4C52"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'CaretIcon',
  props: {
    width: {
      type: Number,
      default: 12,
    },
    height: {
      type: Number,
      default: 12,
    },
  },
};
</script>
